import { memo } from 'react'

import { Box, Typography } from '@mui/material'

// TODO: Rebuild invitation flow with BFF auth
const DynamicFlowContentRaw = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4 }}>
      <Typography variant="heading-lg">Invitation Processing</Typography>
      <Typography variant="text">This feature is being rebuilt. Please contact your administrator.</Typography>
    </Box>
  )
}

export const DynamicFlowContent = memo(DynamicFlowContentRaw)
